module.exports = __webpack_public_path__ + "static/media/bgEngineer.7bd924e9.jpg";